import * as React from 'react';

import * as styles from './SearchSuggestIcon.css';

interface ISearchSuggestIconProps {
  imageUrl: string;
}

export const SearchSuggestIcon: React.FC<ISearchSuggestIconProps> = ({ imageUrl }) => {
  return <div className={styles['image']} style={{ backgroundImage: `url(${imageUrl})` }} />;
};
